module.exports = __webpack_public_path__ + "static/works-dci-84f119adb1c8f68cb9c904b293da5208.png";